import React, { Children } from 'react';
import { motion } from 'framer-motion';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const childrenRules = ['Children will greet their parents when they enter the house and tell them goodbye when they leave.', 'Children will at all times be respectful to their parents and grandparents.', 'Children will at all times be truthful.', 'Children will strive for a good relationship with their brothers and sisters.', 'Children will willingly help with household chores.', 'Children will report to their parents that they have completed assigned tasks.', 'Children will be responsible for the upkeep and neatness of their own room.', 'Children will practice daily cleanliness in the matter of hair, teeth and body.', "Children will abide by their parent's decision.", 'Children will not interrupt adult conversations.', 'Children will refrain from rowdy behavior at home.', 'Children will possess an active mind, body and spirit.', 'Children will diligently study their schoolwork both at school and at home.', 'Children will at all times show respect for their school-teachers and their peers.'];
export function HomeRulesSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-704">
      <div className="max-w-4xl mx-auto" data-id="element-705">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} data-id="element-706">
          <div className="text-center mb-12" data-id="element-707">
            <h2 className="text-3xl sm:text-4xl font-black text-[#0f1f3d] mb-4" data-id="element-708">
              Children's Home Rules
            </h2>
            <div className="w-24 h-1 bg-[#a3d977] mx-auto rounded-full" data-id="element-709"></div>
          </div>

          <ol className="space-y-4 text-left sm:text-center" data-id="element-710">
            {childrenRules.map((rule, idx) => <motion.li key={idx} variants={fadeIn} className="text-lg text-gray-700 leading-relaxed" data-id="element-711">
                <span className="font-bold text-[#0f1f3d] mr-2" data-id="element-712">
                  {idx + 1}.
                </span>
                {rule}
              </motion.li>)}
          </ol>
        </motion.div>
      </div>
    </section>;
}